module.exports = __webpack_public_path__ + "static/media/greenline-logo.efbf5a72.svg";